import { render, staticRenderFns } from "./myUpload.vue?vue&type=template&id=2af5bf8a&scoped=true&"
import script from "./myUpload.vue?vue&type=script&lang=js&"
export * from "./myUpload.vue?vue&type=script&lang=js&"
import style0 from "./myUpload.vue?vue&type=style&index=0&id=2af5bf8a&lang=scss&scoped=true&"
import style1 from "./myUpload.vue?vue&type=style&index=1&id=2af5bf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5bf8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af5bf8a')) {
      api.createRecord('2af5bf8a', component.options)
    } else {
      api.reload('2af5bf8a', component.options)
    }
    module.hot.accept("./myUpload.vue?vue&type=template&id=2af5bf8a&scoped=true&", function () {
      api.rerender('2af5bf8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/myUpload.vue"
export default component.exports